// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1VtsU","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3a0BW","obliqueLine":"membershipbadge_obliqueLine__925Ep"};